var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneNumbersEnricher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00307,
    stopColor: "#56c5ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38156,
    stopColor: "#5674ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#565def"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5623ee"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.43445,60.56556c10.80854,10.80854,24.35047,14.79077,30.24668,8.89456,1.17423-1.17423,1.95512-2.65248,2.36875-4.35175.40214-1.6518-.09572-3.39759-1.29783-4.5997l-4.1099-4.1099c-1.90436-1.90436-4.99195-1.90436-6.89635.00004l-1.52217,1.52217c-1.74908,1.74908-4.52185,1.89099-6.46426.35948-1.77642-1.40056-3.55471-2.99256-5.30098-4.73883s-3.33831-3.5246-4.73883-5.30098c-1.53151-1.94241-1.38961-4.71518.35948-6.46426l1.52217-1.52217c1.9044-1.9044,1.9044-4.99199,0-6.89639l-4.1099-4.1099c-1.20207-1.20207-2.94787-1.69993-4.5997-1.29783-1.69923.41367-3.17748,1.19456-4.35171,2.36879-5.89621,5.89621-1.91398,19.43814,8.89456,30.24668Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "71.35331 34.73978 64.90714 34.73978 64.90714 28.29362 59.18876 28.29362 59.18876 34.73978 52.74259 34.73978 52.74259 40.45817 59.18876 40.45817 59.18876 46.90433 64.90714 46.90433 64.90714 40.45817 71.35331 40.45817 71.35331 34.73978"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneNumbersEnricher);
export default __webpack_public_path__ + "static/media/phone-numbers-enricher.47f4ca9614f86905a6f80eac5f58db2e.svg";
export { ForwardRef as ReactComponent };